'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ImageFrame = require('./ImageFrame');

var _ImageFrame2 = _interopRequireDefault(_ImageFrame);

var _ImagePlaceholderFrame = require('./ImagePlaceholderFrame');

var _ImagePlaceholderFrame2 = _interopRequireDefault(_ImagePlaceholderFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PickerControl = function () {
  function PickerControl(element, args) {
    var _this = this;

    _classCallCheck(this, PickerControl);

    var div = document.createElement('div');
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.property = document.createElement('div');
    this.property.className = 'contact';
    this.property.onclick = args.readonly ? null : args.onclick;
    this.value = args.value;
    this.item = args.item;
    this.image = undefined;
    this.placeholder = undefined;
    this.onchange = args.onchange;

    if (this.item && this.item.getImage()) {
      this.image = new _ImageFrame2.default(this.property, {
        image: this.item.getImage()
      });
    } else {
      this.placeholder = new _ImagePlaceholderFrame2.default(this.property, {
        title: this.item ? this.item.getTitle() : null
      });
    }

    var dl = document.createElement('dl');
    this.dt = document.createElement('dt');
    this.dt.innerHTML = this.item ? this.item.getTitle() : 'Onbekend';
    this.dd = document.createElement('dd');
    this.dd.innerHTML = this.item ? this.item.getSubtitle() : '';

    dl.appendChild(this.dt);
    dl.appendChild(this.dd);
    this.property.appendChild(dl);

    var button = document.createElement('button');
    button.className = 'icon';
    button.innerHTML = '\uE06D';
    button.onclick = function () {
      if (args.onselect) {
        args.onselect(_this.item);
      }
    };

    div.appendChild(this.label);
    div.appendChild(this.property);
    div.appendChild(button);

    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);

    element.appendChild(fragment);
  }

  _createClass(PickerControl, [{
    key: 'getTitle',
    value: function getTitle() {
      return this.dt.innerHTML;
    }
  }, {
    key: 'setTitle',
    value: function setTitle(text) {
      this.dt.innerHTML = text;
    }
  }, {
    key: 'getImage',
    value: function getImage() {
      if (this.image) {
        return this.image.getImage();
      }
    }
  }, {
    key: 'setImage',
    value: function setImage(newImage) {
      if (!newImage) {
        if (this.placeholder) {
          this.placeholder.setTitle(this.item ? this.item.getTitle() : null);
        } else {
          this.placeholder = new _ImagePlaceholderFrame2.default(null, { title: this.item ? this.item.getTitle() : null });
          this.property.insertBefore(this.placeholder.getElement(), this.property.childNodes[0]);
        }

        if (this.image) {
          this.property.removeChild(this.image.getElement());
          this.image = undefined;
        }

        return;
      }

      if (this.image) {
        this.image.setImage(newImage);
      } else {
        this.image = new _ImageFrame2.default(null, { image: newImage });
        this.property.insertBefore(this.image.getElement(), this.property.childNodes[0]);
      }

      if (this.placeholder) {
        this.property.removeChild(this.placeholder.getElement());
        this.placeholder = undefined;
      }
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle() {
      return this.dd.innerHTML;
    }
  }, {
    key: 'setSubtitle',
    value: function setSubtitle(text) {
      this.dd.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.value;
    }
  }, {
    key: 'getItem',
    value: function getItem() {
      return this.item;
    }
  }, {
    key: 'setValue',
    value: function setValue(newValue, newItem) {
      this.value = newValue;
      this.item = newItem;
      this.setImage(this.item && this.item.getImage ? this.item.getImage() : null);
      this.setTitle(this.item && this.item.getTitle ? this.item.getTitle() : 'Onbekend');
      this.setSubtitle(this.item && this.item.getSubtitle ? this.item.getSubtitle() : '');
    }
  }, {
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }]);

  return PickerControl;
}();

exports.default = PickerControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/PickerControl.js
// module id = 54
// module chunks = 0